export const searchFunction = (value: string, data: string[]): string[] => {
  if (value === "") {
    return data; // Return the original data
  } else {
    const updatedCountries = data.filter((item) =>
      item.toLowerCase().includes(value.toLowerCase())
    );
    return updatedCountries; // Return the filtered array
  }
};
